<script setup>
import { computed } from 'vue';
import WhatsAppTemplateParser from 'dashboard/components-next/whatsapp/WhatsAppTemplateParser.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  template: {
    type: Object,
    default: () => ({}),
  },
  contact: {
    type: Object,
    default: () => ({}),
  },
  currentUser: {
    type: Object,
    default: () => ({}),
  },
  inboxName: {
    type: String,
    default: '',
  },
  accountName: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['sendMessage', 'resetTemplate']);

const systemVariables = computed(() => {
  const vars = [];
  if (props.contact?.name) {
    vars.push({
      label: 'Nome do contato',
      value: props.contact.name,
      hint: props.contact.name,
    });
    const parts = props.contact.name.trim().split(/\s+/);
    if (parts.length > 0)
      vars.push({ label: 'Primeiro nome', value: parts[0], hint: parts[0] });
  }
  if (props.contact?.phone_number)
    vars.push({
      label: 'Telefone do contato',
      value: props.contact.phone_number,
      hint: props.contact.phone_number,
    });
  if (props.contact?.email)
    vars.push({
      label: 'Email do contato',
      value: props.contact.email,
      hint: props.contact.email,
    });
  if (props.currentUser?.name)
    vars.push({
      key: 'nome_agente',
      label: 'Nome do agente',
      value: props.currentUser.name,
      hint: props.currentUser.name,
    });
  if (props.inboxName)
    vars.push({
      label: 'Canal de atendimento',
      value: props.inboxName,
      hint: props.inboxName,
    });
  if (props.accountName)
    vars.push({
      label: 'Nome da empresa',
      value: props.accountName,
      hint: props.accountName,
    });
  return vars;
});

const handleSendMessage = payload => {
  emit('sendMessage', payload);
};

const handleResetTemplate = () => {
  emit('resetTemplate');
};
</script>

<template>
  <div class="w-full">
    <WhatsAppTemplateParser
      :template="template"
      :system-variables="systemVariables"
      @send-message="handleSendMessage"
      @reset-template="handleResetTemplate"
    >
      <template #actions="{ sendMessage, resetTemplate, disabled }">
        <footer class="flex gap-2 justify-end">
          <NextButton
            faded
            slate
            type="reset"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.GO_BACK_LABEL')"
            @click="resetTemplate"
          />
          <NextButton
            type="button"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.SEND_MESSAGE_LABEL')"
            :disabled="disabled"
            @click="sendMessage"
          />
        </footer>
      </template>
    </WhatsAppTemplateParser>
  </div>
</template>
